import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const NewDutAccordionItem = ({
  title,
  children,
  expanded,
  onChange,
  wrapperClassName = "",
}) => {
  return (
    <div className={`rounded-[16px] overflow-hidden ${wrapperClassName}`}>
      <Accordion
        expanded={expanded}
        onChange={onChange}
        disableGutters
        elevation={0}
        square={false}
        sx={{
          backgroundColor: "#FFFFFF",
          boxShadow: "none",

          overflow: "visible",
          margin: "0 !important",
          "&::before": {
            display: "none",
          },
        }}
        // className="rounded-[16px] border border-[#E4E4E4]"
      >
        <AccordionSummary
          expandIcon={
            <div className="flex justify-center items-center w-[32px] h-[32px] 2xl:w-[40px] 2xl:h-[40px] rounded-full bg-[#FFFFFF]">
              <ExpandMoreIcon className="text-[#1A1A1A]" />
            </div>
          }
          sx={{
            minHeight: "72px !important",
            "& .MuiAccordionSummary-content": {
              margin: "0 !important",
              alignItems: "center",
            },
          }}
          className="px-[16px] py-[30px] bg-[#FFFFFF]"
        >
          <div className="font-lufga text-[#1A1A1A] font-normal text-[18px] xl:text-[24px] 2xl:text-[28px] 3xl:text-[34px] leading-[100%] tracking-[-0.03em]">
            {title}
          </div>
        </AccordionSummary>

        <AccordionDetails
          className="
          px-[16px]
          pb-[20px]

          xl:px-[20px]
          xl:pb-[24px]

          2xl:px-[28px]
          2xl:pb-[32px]

          3xl:px-[36px]
          3xl:pb-[40px]
        "
        >
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default NewDutAccordionItem;
